import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import CustomisedChip from "../../../../common/Modules/CustomisedChip";
import {
  APIFILTERLIST,
  APPLICABLE_ROLE,
  CONSULTATIONTYPE,
  HEADERLIST,
  SELECTEDFILTERTITLE,
} from "../../../Constant";
import {
  removeDashboardFilterFromLocalStorage,
  removeQuery,
} from "../../../Helper";
import "./dashboardAppointmentsViewTableHeader.scss";
import { USER_ROLE } from "../../../../../Util/constants";

const DashboardAppointmentsViewTableHeader = (props) => {
  const {
    user_type,
    doctorRole,
    selectedFilters,
    selectedStatusCard,
    consultation_type,
  } = props;
  const history = useHistory();
  const location = useLocation();

  // Helper methods ==>

  const getClassName = (hl) => {
    let name = "col-md-3";
    if (hl.title === HEADERLIST.DATETIME) {
      name = "col-md-2 pl-2";
    } else if (hl.title === "" || hl.title === HEADERLIST.STATUS) {
      name = "col-md-2";
    } else if (hl.title === HEADERLIST.CONSULTATION) {
      if (
        user_type !== APPLICABLE_ROLE.STAFF &&
        doctorRole !== USER_ROLE.DOCTOR_ADMIN &&
        doctorRole !== USER_ROLE.RESOURCE_ADMIN
      ) {
        name = "col-md-3 pl-3";
      }
    } else if (hl.title === HEADERLIST.PATIENTDETAILS) {
      if (
        user_type === APPLICABLE_ROLE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN
      ) {
        name = "col-md-2";
      }
    } else if (hl.title === HEADERLIST.DOCTORNAME) {
      name = "col-md-2";
    }

    return name;
  };

  // <===

  // Actions ==>

  const handleChipDelete = (id) => {
    switch (id) {
      case APIFILTERLIST.CONSULTATION:
        removeQuery(history, location, [
          APIFILTERLIST.CONSULTATION,
          APIFILTERLIST.IS_PROCEDURE,
        ]);
        break;
      case APIFILTERLIST.STATUS:
        removeQuery(history, location, [APIFILTERLIST.STATUS]);
        break;
      case APIFILTERLIST.DOCTORNAME:
        removeQuery(history, location, [
          APIFILTERLIST.DOCTORNAME,
          APIFILTERLIST.DOCTOR_NAME,
        ]);
        break;
      case APIFILTERLIST.PRESCRIPTION_FILTER:
        removeQuery(history, location, [APIFILTERLIST.PRESCRIPTION_FILTER]);
        break;
      default:
        break;
    }
  };

  const clearAllFilters = () => {
    let consultation_type = new URLSearchParams(location.search).get(
      APIFILTERLIST.CONSULTATION_TYPE
    );
    let start_date = new URLSearchParams(location.search).get(
      APIFILTERLIST.STARTDATE
    );
    let sortOrder = new URLSearchParams(location.search).get(
      APIFILTERLIST.SORTORDER
    );
    removeDashboardFilterFromLocalStorage();
    history.push({
      pathname: location.pathname,
      search: `?${APIFILTERLIST.CONSULTATION_TYPE}=${consultation_type}&${APIFILTERLIST.STARTDATE}=${start_date}&${APIFILTERLIST.SORTORDER}=${sortOrder}`,
    });
  };

  // <===

  // Create UI ==>

  const displayDashboardMainContentHeader = () => {
    return (
      <>
        <div className="dashboard-appointments-table-header">
          <div className="row header d-none d-sm-none d-md-flex">
            {props?.headerList?.map((hl, ind) => (
              <div className={getClassName(hl)} key={ind}>
                <span>{hl.title}</span>
                {hl.filter_icon && (
                  <span style={{ marginLeft: "10px", position: "relative" }}>
                    {(hl.title === HEADERLIST.STATUS &&
                      selectedStatusCard !== "total") ||
                    (hl.title === HEADERLIST.CONSULTATION &&
                      consultation_type ===
                        CONSULTATIONTYPE.INSTANT.toLowerCase()) ? null : (
                      <img
                        src={hl.filter_icon}
                        alt=""
                        style={{ marginBottom: "3px", cursor: "pointer" }}
                        onClick={() => props.openMenuList(hl)}
                      />
                    )}
                    {hl.show_filter && props.displayNormalFilterList(hl)}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
        {selectedFilters?.length > 0 && displaySelectedFilters()}
      </>
    );
  };

  const displaySelectedFilters = () => {
    return (
      <div className="dashborad-appointments-filter-chips d-flex">
        {selectedFilters.map((sl, ind) => (
          <div className="deletable-chip" key={ind}>
            <CustomisedChip
              label={sl.label}
              id={sl.id}
              deletable={true}
              deleteHandler={handleChipDelete}
            />
          </div>
        ))}
        {selectedFilters.length > 0 && (
          <div className="clear-all-chip">
            <CustomisedChip
              label={SELECTEDFILTERTITLE.CLEARALL}
              id={SELECTEDFILTERTITLE.CLEARALL}
              clickHandler={clearAllFilters}
            />
          </div>
        )}
      </div>
    );
  };

  // <===

  return <>{displayDashboardMainContentHeader()}</>;
};

export default DashboardAppointmentsViewTableHeader;
